import { ParseMapOptions } from "@/components/parser/types";
import { domToReact, Element } from "html-react-parser";
import { parseByNodeString, parseMap } from "@/components/parser/Mapper";
import styles from "@/styles/post.module.css";
import React, { createElement, Fragment } from "react";
import { AdvertisementBlock } from "@/components/layout/AdvertisementBlock";

export const Paragraph = (domNode: Element, options: ParseMapOptions): JSX.Element | undefined => {
  return (
    <>
      <p className={styles.postParagraph}>
        {domToReact(domNode.children, {
          replace: (domNode) => {
            if (!domNode.hasOwnProperty("attribs")) {
              return;
            }
            const domNodeElement = domNode as Element;

            return parseByNodeString(parseMap, domNodeElement.name, domNodeElement, options);
          },
        })}
      </p>
      {!options.ignoreAds &&
        options.paragraphCounter &&
        options.paragraphCounter === 3 &&
        !options.displayedFirstAd && <AdvertisementBlock id={"protag-Hero_in_content_1"} />}

      {!options.ignoreAds && options.paragraphCounter && options.paragraphCounter === 5 && (
        <AdvertisementBlock id={"protag-in_article_video"} />
      )}

      {!options.ignoreAds && options.paragraphCounter && options.paragraphCounter === 13 && (
        <AdvertisementBlock id={"protag-Hero_in_content_2"} />
      )}
    </>
  );
};

export const Heading = (domNode: Element, options: ParseMapOptions): JSX.Element | undefined => {
  return createElement(
    domNode.name,
    { className: styles[domNode.name] },
    domToReact(domNode.children, {
      replace: (domNode) => {
        if (!domNode.hasOwnProperty("attribs")) {
          return;
        }
        const domNodeElement = domNode as Element;

        return parseByNodeString(parseMap, domNodeElement.name, domNodeElement, options);
      },
    })
  );
};

export const Figcaption = (domNode: Element, options: ParseMapOptions): JSX.Element | undefined => {
  if (domNode.attribs) {
    const domNodeDeepClone = structuredClone(domNode);
    domNodeDeepClone.attribs.class = "font-sans mt-2 text-md ";

    return <Fragment>{domToReact([domNodeDeepClone])}</Fragment>;
  }

  return;
};
